export default __webpack_public_path__ + "images/01e4cab1635f1630adb33e4f77966206.png";